import React from 'react';
const POINTS = [{
  icon: '🔧',
  title: 'Visual diagnostic resources',
  body: 'Find the right fault-finding reference when you need it.'
}, {
  icon: '📋',
  title: 'Structured diagnostic paths',
  body: 'Move from symptom or trouble code to possible cause with a clearer process.'
}, {
  icon: '🚗',
  title: '6 diagnostic areas',
  body: 'Workflow, engine, electrical, OBD-II, symptoms and electronic networks.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the tools whenever a new vehicle problem appears.'
}];
export function NotAnEbook() {
  return <section className="bg-navy px-4 py-6 text-white sm:py-8" data-id="element-112" data-mp="3chrx2uxphc4k">
      <div className="mx-auto max-w-5xl text-center" data-id="element-113" data-mp="37j8aqtf79ybo">
        <h2 className="text-2xl sm:text-4xl" data-id="element-114" data-mp="37kt44fps3b7y">
          THIS ISN&apos;T JUST ANOTHER AUTOMOTIVE EBOOK
        </h2>
        <p className="mt-1 font-display text-xl uppercase tracking-wide text-cyan sm:text-3xl" data-id="element-115" data-mp="15r263ncoy16z">
          It&apos;s a ready-to-use diagnostic system.
        </p>

        <ul className="mt-4 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-4" data-id="element-116" data-mp="3n25pfh0svb9i">
          {POINTS.map(point => <li key={point.title} className="rounded-xl border border-cyan/25 bg-white/5 p-3.5" data-id="element-117" data-mp="3s079a461vem1">
              <p className="text-xl leading-none" aria-hidden="true" data-id="element-118" data-mp="3i3kplipgmtll">
                {point.icon}
              </p>
              <h3 className="mt-1.5 text-base text-white sm:text-lg" data-id="element-119" data-mp="9pvl6936lnfw">
                {point.title}
              </h3>
              <p className="mt-1 text-sm font-medium leading-snug text-white/75" data-id="element-120" data-mp="emvsenbrow8l">
                {point.body}
              </p>
            </li>)}
        </ul>

        <p className="mt-3 font-display text-lg uppercase tracking-wide text-cyan sm:text-2xl" data-id="element-121" data-mp="4wsq1wira5xl">
          Less searching. Less guessing. More structure.
        </p>
      </div>
    </section>;
}